import { Box, Flex, Grid, Spinner, Text } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useMoralisQuery } from 'react-moralis';
import { Link } from 'react-router-dom';
import { GamePanel } from 'src/components/common/GamePanel/gamePanel';
import { useBlockchainProvider } from 'src/providers/Blockchain/blockchainProvider';
import { Color } from 'src/theme/color';
import { config } from "../../config";

export const containerStyle = {};

export interface GamePanelItem {
	id: string;
	cartridgeAddress: string;
	name: string;
	symbol: string;
	logoUrl: string;
	price: string;
	listed: boolean;
	patchkitAppId?: string;
	platforms: string[];
	genres: string[];
	colors: any;
	color: string;
	creator: string;
	screenshots: string[];
	marketplaceFee: string | null
}

export const Games = () => {
	const { t } = useTranslation();
	const { account, isChainValid } = useBlockchainProvider();

	const { data, error, isLoading } = useMoralisQuery(
		'Games',
		query => query.equalTo('creator', account.toLowerCase()),
		[account]
	);

	useEffect(() => console.log('loading games',config, data, error, isLoading), [])

	const [games, setGames] = useState<GamePanelItem[]>([]);

	useEffect(() => {
		if (data.length > 0) {
			const mapped = data.map(el => ({
				id: el.id,
				cartridgeAddress: el.attributes.address,
				symbol: el.attributes.symbol,
				name: el.attributes.name,
				logoUrl: el.attributes.media.logoUrl,
				price: el.attributes.price,
				listed: el.attributes.listed,
				creator: el.attributes.creator,
				patchkitAppId: el.attributes.patchkitAppId,
				platforms: el.attributes.platforms,
				colors: el.attributes.colors,
				screenshots: el.attributes.screenshots,
				genres: el.attributes.genres,
				color: el.attributes.color,
				marketplaceFee: el.attributes.marketplaceFee
			}));
			console.log(mapped)
			setGames(mapped);
		}
	}, [data]);

	return (
		<>
			<Flex
				display={{ base: 'none', md: 'flex' }}
				w="100%"
				flexDir="column"
				color="white"
			>
				<Grid
					bg="black"
					padding="13px 50px"
					templateColumns="300px 140px 100px auto 100px"
					gridGap="20px"
					fontSize="12px"
					fontWeight="bold"
					justifyItems="start"
					alignItems="center"
					borderRadius="4px 4px 0px 0px"
				>
					<Text>{t('yourGames.columns.name')}</Text>
					<Text>{t('yourGames.columns.details')}</Text>
					<Text>{t('yourGames.columns.price')}</Text>
					<Text>{t('yourGames.columns.platform')}</Text>
					<Text>{t('yourGames.columns.status')}</Text>
				</Grid>
				<Flex
					flexDir="column"
					bg={Color.BLACK_3}
				>
					{isLoading ? (
						<Flex
							minHeight="200px"
							justify="center"
							align="center"
						>
							<Spinner
								alignSelf="center"
								justifySelf="center"
							/>
						</Flex>
					) : games.length > 0 ? (
						games.map(game => {
							console.warn(game);
							return (
								<GamePanel
									key={game.id}
									game={game}
								/>
							);
						})
					) : (
						<Flex
							minHeight="200px"
							align="center"
							justify="center"
						>
							No publications found.
							<Link to="/add">
								<Box ml="10px" _hover={{textDecoration: 'underline'}} color={Color.HASHUP}>Publish your first game.</Box>
							</Link>
						</Flex>
					)}
				</Flex>
			</Flex>
			<Flex
				display={{ base: 'flex', lg: 'none' }}
				w="100vw"
				justifyContent="center"
				alignItems="center"
				textTransform="uppercase"
			>
				<Text
					fontFamily="Sora"
					fontSize="25px"
				>
					{t('pages.addGame.mobile')}
				</Text>
			</Flex>
		</>
	);
};
